import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeMode = 'light' | 'dark' | 'kirsty' | 'system';

type AppState = {
  brokerId: string;
  setBrokerId: (brokerId: string) => void;
  themeMode: ThemeMode;
  setThemeMode: (mode: ThemeMode) => void;
};

const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      brokerId: '',
      setBrokerId: (brokerId: string) => set({ brokerId }),
      themeMode: 'system',
      setThemeMode: (themeMode: ThemeMode) => set({ themeMode }),
    }),
    {
      name: 'phyllome-app-store',
      partialize: (state) => ({ themeMode: state.themeMode }),
    },
  ),
);

export default useAppStore;
